<template>
  <div class="forgotten-password-form">
    <b-form v-if="!requestSent" novalidate @submit.stop.prevent="forgottenPassword">
      <b-form-group
        id="email-input-group"
        :label="$t('forgottenPassword.emailLabel')"
        label-for="email-input"
      >
        <b-form-input
          type="email"
          id="email-input"
          name="email"
          v-model="email"
          v-validate="{required: true, email: true}"
          :state="validateState('email')"
        >
        </b-form-input>

        <b-form-invalid-feedback>
          {{$t('forgottenPassword.emailInvalid')}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-row>
        <b-col>
          <loading-button
            :text="$t('forgottenPassword.btnText')"
            :loading-text="$t('forgottenPassword.btnLoadingText')"
            variant="primary"
            :loading=submitting
            type="submit"
            :disabled="veeErrors.any()"
          />
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <p>
            {{$t('forgottenPassword.rememberedPrompt')}}
            <router-link to="/login">{{$t('forgottenPassword.login')}}</router-link>
          </p>
        </b-col>
      </b-row>
    </b-form>

    <div v-else>
      <p>{{$t('forgottenPassword.requestSent')}}</p>
    </div>
  </div>
</template>

<script>
  import FormValidation from '../../mixins/FormValidation';

  export default {
    mixins: [FormValidation],
    data() {
      return {
        submitting: false,
        requestSent: false,
        email: '',
      };
    },
    methods: {
      forgottenPassword() {
        this.$validator.validateAll().then((result) => {
          if (!result) {
            return;
          }
          this.submitting = true;
          this.$store.dispatch('account/forgottenPassword', this.email)
            .finally(() => {
              this.requestSent = true;
              this.submitting = false;
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>
